// removed by extract-text-webpack-plugin
module.exports = {"checkout":"_1PlnW","innerContainer":"_167hQ","storeLogo":"_1G2Bd","empty":"_3cc9g","buttonsContainer":"ZlzgS","continueShoppingButton":"_1PBnN","placeOrderButton":"_3HY4f","paymentMethodButton":"VX1HW","shippingAddressButton":"_27Xkx","invalid":"_37PXk","paymentMethod":"_3gKvH","shippingAddress":"_3alWR","invoice":"_3RaRW","invoiceItem":"_3hpt-","invoiceItemName":"_1udVb","invoiceItemValue":"bERXQ","invoiceItemBold":"_2d41w","securityMessage":"_3b42l","error":"_2Z2rJ","alert":"_3COc5","noShippingMethodAvailable":"_2Np3_","rememberMe":"_31gZB","checkbox":"_3jgJ6","checkboxLabel":"_1RCzd","subtext":"pnmJe"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/Checkout/index.sass
// module id = 1470
// module chunks = 1